import { faker } from '@faker-js/faker'
import { http, HttpResponse } from 'msw'

import { GetCustomerCustomFieldTypesResponse } from '@/api/agency/customers/get-customer-custom-field-types'

export const mockGetCustomerCustomFieldTypes = http.get(
  '/my-business/api/agency/v1/customers/custom-field-types',
  () => {
    const data: GetCustomerCustomFieldTypesResponse = {
      data: Array.from({ length: 10 }, (_, index) => ({
        id: index + 1,
        name: faker.lorem.word().toUpperCase(),
      })),
    }

    return HttpResponse.json(data, { status: 200 })
  },
)
